<!-- Modal REVIEW DETAIL-->
<div class="modal fade contenedor-modal" id="modalReview" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content cm-bg-color-0">
            <div class="modal-body p-0">
                <app-modal-review [review]="reviewSelected" (onClose)="closeReview()">
                </app-modal-review>
            </div>
        </div>
    </div>
</div>

<div class="col-8 offset-2" *ngIf="!loading">
    <div class="col-12 pb-4 px-0" *ngIf="isLogged">
        <app-new-comment-item [authorId]="loggedAccount.id" [filmId]="Movie.id" (onCommented)="cargarComments()">
        </app-new-comment-item>
    </div>
    <ul class="list-group listaComentarios">
        <li *ngFor="let comment of Comments" class="pb-4">
            <app-movie-comment-item [comment]="comment" (onClicked)="openReview(comment)">
            </app-movie-comment-item>
        </li>
    </ul>
    <div class="col-12 pb-4 px-0 ningunCommentParent" *ngIf="Comments.length == 0">
        <span class="ningunComment">Ningun comentario para mostrar</span>
    </div>
</div>